<template>
  <lm-modal
    :ref="modalName"
    :name="modalName"
    class="ModalWhatsNew"
    title="What's New"
    full-height
    remove-footer
    @[Events.AFTER_OPEN]="modalOpened"
  >
    <ul class="News">
      <li v-for="n in news" :key="n.date" class="New">
        <span class="Date">{{ n.date }}</span>
        <h1 class="Title">{{ n.title }}</h1>
        <p class="Description" @click="onClick" v-html="n.description"></p>
      </li>
    </ul>
    <lm-button-next
      v-if="showLoadMore"
      label="Load more"
      icon="sync"
      class="mx-auto"
      @click="loadNews(false)"
    />
  </lm-modal>
</template>

<script>
import LmButtonNext from '@/components/ui/button/LmButtonNext'
import {mapGetters} from 'vuex'
import {Events, Modal} from '@/lib/definitions'
import LmModal from '@/components/ui/LmModal'
import axios from 'axios'

const WhatsNewVars = {CURRENT_LANDSCAPE: 'CURRENT_LANDSCAPE'}
const separator = '#!#'
const ABORT_FLAG = 'xxABORTxx'

export default {
  name: 'ModalWhatsNew',
  components: {
    LmButtonNext,
    LmModal
  },
  data() {
    return {
      Events,
      modalName: Modal.WHATS_NEW,
      modalRef: null,
      domain: process.env.VUE_APP_DOMAIN,
      news: [],
      showLoadMore: true
    }
  },
  computed: {
    ...mapGetters(['currentLandscape', 'startingLandscape', 'landscapes'])
  },
  mounted() {
    this.modalRef = this.$refs[this.modalName]
  },
  created() {
    this.loadNews()
  },
  methods: {
    modalOpened() {
      this.$store.dispatch('whatsNew')
    },
    loadNews(firstTime = true) {
      let file = 'whatsnew'
      if (!firstTime) {
        this.showLoadMore = false
        file = 'whatsnew-next'
      }
      axios
        .get(`${this.domain}static/${file}.json?r=${Date.now()}`)
        .then(res => {
          this.news.push(...res.data)
        })
    },
    onClick(e) {
      if (e.target.attributes['data-type']?.value === 'router-link') {
        const name = e.target.attributes['data-name']?.value
        const paramsString = this.parseVars(
          e.target.attributes['data-params']?.value
        )
        const queryString = this.parseVars(
          e.target.attributes['data-query']?.value
        )

        if (!this.abortNavigation(paramsString, queryString)) {
          const params = this.parseVarsRoute(paramsString)
          const query = this.parseVarsRoute(queryString)
          this.$router.push({
            name,
            params,
            query
          })
        }
      }
    },
    abortNavigation(...p) {
      return p.includes(ABORT_FLAG)
    },
    parseVarsRoute(string) {
      if (!string) return
      let currentParamKey
      let params = {}
      string.split(':').forEach((param, i) => {
        if (i % 2 === 0) {
          currentParamKey = param
        } else {
          params[currentParamKey] = param
        }
      })
      return params
    },
    parseVars(text) {
      if (!text) return
      if (text.indexOf(separator) === -1) return text
      Object.keys(WhatsNewVars).forEach(key => {
        switch (key) {
          case WhatsNewVars.CURRENT_LANDSCAPE: {
            let landscapeSlug
            if (this.currentLandscape) {
              landscapeSlug = this.currentLandscape.slug
            } else if (this.startingLandscape) {
              landscapeSlug = this.startingLandscape
            } else {
              text = ABORT_FLAG
              return
            }

            text = text.replace(
              new RegExp(
                `${separator}${WhatsNewVars.CURRENT_LANDSCAPE}${separator}`,
                'g'
              ),
              landscapeSlug
            )
            break
          }
        }
      })
      return text
    }
  }
}
</script>

<style>
.ModalWhatsNew {
  .Modal-wrapper {
    width: 800px;
  }
  .News {
    margin: 0;
    padding: 0;
    .New {
      margin-bottom: 30px;
      padding-bottom: 10px;
      border-bottom: 1px solid #dcdcdc;
      .Date {
        font-size: 13px;
        color: #969696;
      }
      .Title {
        margin-top: 6px;
        margin-bottom: 15px;
        font-size: 20px;
        line-height: 1.2;
      }
      .Description {
        color: #555;
        .highlight {
          font-weight: 500;
          color: #333333;
        }
      }
    }
  }
}
</style>
